<template>
  <div ref="NeyslaInstalation" class="transparent">
    <p>{{ $t('portfolio.neysla.installation.descriptionLabel') }}</p>

    <h2>{{ $t('portfolio.npmPackages.introduction') }}</h2>
    <hr class="secondary">
    <p>
      {{ $t('portfolio.neysla.installation.introduction.paragraph') }}
      <ul>
        <li><b>{{ $t('portfolio.neysla.directUsage.pageLabel') }}</b>: {{ $t('portfolio.neysla.installation.introduction.paragraphDirectUsage') }}</li>
        <li><b>{{ $t('portfolio.neysla.modelerUsage.pageLabel') }}</b>: {{ $t('portfolio.neysla.installation.introduction.paragraphModelerUsage') }}</li>
      </ul>
    </p>

    <h2>{{ $t('portfolio.npmPackages.versioning.title') }}</h2>
    <hr class="secondary">
    <p>
      {{ $t('portfolio.npmPackages.versioning.paragraph') }}
      <a
        href="https://semver.org/spec/v2.0.0.html"
        class="general-anchor decorated"
        rel="noreferrer,noopener"
        target="_blank"
      >
        <span>semver</span>
      </a>.
    </p>

    <h2>{{ $t('portfolio.npmPackages.license.title') }}</h2>
    <hr class="secondary">
    <p>{{ $t('portfolio.npmPackages.license.paragraph') }}</p>

    <h2>{{ $t('portfolio.npmPackages.preRequisites') }}</h2>
    <hr class="secondary">
    <ul>
      <li>Node 10+</li>
      <li>NPM 6+</li>
    </ul>

    <h2>{{ $t('portfolio.npmPackages.installation') }}</h2>
    <hr class="secondary">

    <h3>{{ $t('portfolio.neysla.installation.installationStep.subtitleCDN') }}</h3>
    <pre v-highlight class="highlight">
      <code class="xml">
...
  &#60;script type="text/javascript" src="https://unpkg.com/neysla@3.8.3/build/cdn/neysla.min.js" charset="utf-8"&#62;&#60;&#47;script&#62;
...
      </code>
    </pre>
    <p>{{ $t('portfolio.neysla.installation.installationStep.paragraphCDN') }}</p>
    <pre v-highlight class="highlight">
      <code class="javascript">
...
  console.log("Neysla: ", Neysla);
...
      </code>
    </pre>

    <h3>{{ $t('portfolio.neysla.installation.installationStep.subtitleNPM') }}</h3>
    <pre v-highlight class="highlight">
      <code>
npm install --save neysla
      </code>
    </pre>
    <p>{{ $t('portfolio.neysla.installation.installationStep.paragraphNPM') }}</p>
    <pre v-highlight class="highlight">
      <code class="javascript">
...
  import Neysla from "neysla";
...
      </code>
    </pre>
  </div>
</template>

<script>
export default {
  name: "NeyslaInstalation"
};
</script>
